import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { router } from 'modules/common/utils';
import { Icon, DropdownToggle } from 'modules/common/components';
import { PerPageButton, Option } from './styles';
import { Dropdown } from 'react-bootstrap';
import { extend } from 'jquery';
import { render } from 'react-dom';

// per page chooser component
class ReportPerPageChooser extends Component {

 constructor(props) {
  super(props);
 }

 render() {
  let { history, perPage, onPerPageChooser } = this.props;
  let { __ } = this.context;
 
  const currentPerPage = perPage;

  const onClick = perPage => {
    onPerPageChooser(perPage);
  };

  const renderOption = number => {
    return (
      <Option>
        <a onClick={() => onClick(number)}>{number}</a>
      </Option>
    );
  };

  return (
    <Dropdown id="per-page-chooser" className="dropup">
      <DropdownToggle bsRole="toggle">
        <PerPageButton>
          {/* {currentPerPage} {__('per page')} <Icon icon="uparrow-2" /> */}
          {currentPerPage} <Icon icon="downarrow-2" />
        </PerPageButton>
      </DropdownToggle>
      <Dropdown.Menu>
        {renderOption(10)}
        {renderOption(20)}
        {renderOption(30)}
        {renderOption(50)}
        {renderOption(100)}
        {renderOption(200)}
      </Dropdown.Menu>
    </Dropdown>
  );
 }
  
};
// const ReportPerPageChooser = (
//   { history, perPage, onPerPageChooser },
//   { __ }
// ) => {
//   const currentPerPage = perPage;

//   const onClick = perPage => {
//     onPerPageChooser(perPage);
//   };

//   const renderOption = number => {
//     return (
//       <Option>
//         <a onClick={() => onClick(number)}>{number}</a>
//       </Option>
//     );
//   };

//   return (
//     <Dropdown id="per-page-chooser" className="dropup">
//       <DropdownToggle bsRole="toggle">
//         <PerPageButton>
//           {/* {currentPerPage} {__('per page')} <Icon icon="uparrow-2" /> */}
//           {currentPerPage} <Icon icon="downarrow-2" />
//         </PerPageButton>
//       </DropdownToggle>
//       <Dropdown.Menu>
//         {renderOption(10)}
//         {renderOption(20)}
//         {renderOption(30)}
//         {renderOption(50)}
//         {renderOption(100)}
//         {renderOption(200)}
//       </Dropdown.Menu>
//     </Dropdown>
//   );
// };

ReportPerPageChooser.propTypes = {
  history: PropTypes.object.isRequired
};

ReportPerPageChooser.contextTypes = {
  __: PropTypes.func
};

export default withRouter(ReportPerPageChooser);



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/reportPagination/ReportPerPageChooser.js